var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"title":"Alistamiento","sub-title":"Alistamiento de kits"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('enlistment-dispatch-card')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }